import { gql } from 'src/__generated__';

export const userDetails = gql(`
  fragment UserDetailsFragment on Candidate {
    _id
    emailAddress
    trackingId
    personalDetails {
      firstName
      lastName
      phoneNumber
      countryCallingCode {
        id
        countryCallingCode
      }
      defaultCountryCallingCode {
        id
        countryCallingCode
      }
    }
  }
`);

export const GET_USER = gql(`
  query GetUser {
    viewer {
      ...UserDetailsFragment
      profileVisibility2 {
        id
      }
    }
  }
`);
